import { render, staticRenderFns } from "./FileAttachmentSupplemental.vue?vue&type=template&id=12bdbb50"
import script from "./FileAttachmentSupplemental.vue?vue&type=script&lang=js"
export * from "./FileAttachmentSupplemental.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports